import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ContactModal } from './ContactModal';
// Extra vertical offset per section so the nav buttons land in the exact
// same spot as the side-nav buttons in pages/Home.tsx.
const SECTION_EXTRA_OFFSET: Record<string, number> = {
  colecciones: 0,
  'mas-alla': 120,
  nosotros: 184
};
export function Nav() {
  const [solid, setSolid] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const contactTriggerRef = useRef<HTMLButtonElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (!isMobileMenuOpen) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsMobileMenuOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isMobileMenuOpen]);
  const scrollToSection = (id: string) => {
    const target = document.getElementById(id);
    if (!target) return;
    const nav = document.getElementById('nav');
    const offset = (nav?.offsetHeight ?? 0) + 24;
    const extra = SECTION_EXTRA_OFFSET[id] ?? 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset + extra;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };
  const handleSectionClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      // Navigate home first, then scroll once the section is mounted.
      navigate('/');
      window.setTimeout(() => scrollToSection(id), 80);
      return;
    }
    scrollToSection(id);
  };
  const openContact = () => {
    setIsMobileMenuOpen(false);
    setIsContactOpen(true);
  };
  const closeContact = () => {
    setIsContactOpen(false);
    window.setTimeout(() => contactTriggerRef.current?.focus(), 0);
  };
  return <>
      <nav className={`nav ${solid ? 'nav--solid' : ''}`} id="nav" data-id="element-176">
        <Link to="/#inicio" className="nav__logo" onClick={e => {
        e.preventDefault();
        if (location.pathname !== '/') {
          navigate('/');
          window.setTimeout(() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          }), 80);
          return;
        }
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} data-id="element-177">
          SAVIA
        </Link>
        <ul className={`nav__links ${isMobileMenuOpen ? 'nav__links--open' : ''}`} id="mobile-navigation" data-id="element-178">
          <li data-id="element-179">
            <Link to="/#colecciones" onClick={e => handleSectionClick(e, 'colecciones')} data-id="element-180">
              Colecciones
            </Link>
          </li>
          <li data-id="element-181">
            <Link to="/#mas-alla" onClick={e => handleSectionClick(e, 'mas-alla')} data-id="element-182">
              Kits & Objetos
            </Link>
          </li>
          <li data-id="element-183">
            <Link to="/#nosotros" onClick={e => handleSectionClick(e, 'nosotros')} data-id="element-184">
              Nosotros
            </Link>
          </li>
          <li data-id="element-185">
            <button ref={contactTriggerRef} type="button" className="nav__contact" onClick={openContact} aria-haspopup="dialog" aria-expanded={isContactOpen} data-id="element-186">
              Contacto
            </button>
          </li>
        </ul>
        <button type="button" className="nav__hamburger" onClick={() => setIsMobileMenuOpen(isOpen => !isOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} aria-controls="mobile-navigation" data-id="element-187">
          <span data-id="element-188"></span>
          <span data-id="element-189"></span>
          <span data-id="element-190"></span>
        </button>
      </nav>
      <ContactModal isOpen={isContactOpen} onClose={closeContact} data-id="element-191" />
    </>;
}